<template>
    <div class="w-full">
        <custom-simple-select
            v-model="option"
            label="Solicitado en"
            :options="selectOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { productExtraOptionSectionWhereRequested } from "@/common/fields/product-extra-option-section-where-requested";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "ProductExtraOptionSectionWhereRequestedSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: String,
            default: () => "",
            required: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: Object.keys(productExtraOptionSectionWhereRequested)[0],
        $enabledOptions: productExtraOptionSectionWhereRequested
    }),
    computed: {
        selectOptions() {
            return Object.entries(this.$data.$enabledOptions).map(
                ([key, value]) => ({ label: value, value: key })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
